import Resource from '@/plugins/sdk/Resource'
import { DATETIME, STRING, UUID, INTEGER } from '@/plugins/sdk/fields'

export default class extends Resource {
  static name = 'enquiry_contact'

  static get fields () {
    return {
      id: new UUID(),
      name: new STRING(),
      title: new STRING(),
      phone: new STRING(),
      mobile: new STRING(),
      email: new STRING(),
      address: new STRING(),
      notes: new STRING(),
      type: new INTEGER(),
      created_at: new DATETIME(),
      updated_at: new DATETIME(),
      deleted_at: new DATETIME()
    }
  }
}
